/**
 * Returns device screen width or height
 * @param {String} measureType - measure which size need to get ("width" or "height")
 * @returns {Number|Null} - `null` if unknown
 */
export default function getIndependentScreenSize(measureType = "width") {
  if (typeof window === "undefined") return null;
  return window.screen[measureType];
}
